import { createReducer, on } from '@ngrx/store';
import cloneDeep from 'lodash.clonedeep';
import { resetAllCustomPdfReportItems } from '../actions';
import { addSelectedReportWizardStep, removeSelectedReportWizardStep, resetSelectedReport, setReportTitle, setSelectedReport, setSelectedReportWizardSteps, updateSelectedReportWizardStep, } from './selected-report.actions';
export const selectedReport = createReducer({}, on(setSelectedReport, (state, action) => {
    if (action.reportData === undefined) {
        return {};
    }
    return action.reportData;
}), on(resetSelectedReport, () => {
    return {};
}), on(resetAllCustomPdfReportItems, () => {
    return {};
}), on(addSelectedReportWizardStep, (state, action) => {
    // Prevent duplicate entries
    const duplicateEntry = state.wizard_steps.some((step) => step.eventName === action.newStep.eventName);
    if (duplicateEntry)
        return state;
    return {
        ...state,
        wizard_steps: [
            ...state.wizard_steps.slice(0, action.index),
            action.newStep,
            ...state.wizard_steps.slice(action.index),
        ],
    };
}), on(setSelectedReportWizardSteps, (state, action) => {
    return {
        ...state,
        wizard_steps: action.wizardSteps,
    };
}), on(removeSelectedReportWizardStep, (state, action) => {
    return {
        ...state,
        wizard_steps: state.wizard_steps.filter((step) => step.eventName !== action.eventName),
    };
}), on(updateSelectedReportWizardStep, (state, action) => {
    const newState = cloneDeep(state);
    newState.wizard_steps = state.wizard_steps.map((step) => {
        // if the step has different name or modules, then it is not the step we are looking for
        if (step.eventName !== action.newStep.eventName)
            return step;
        if (step.modules?.length !== action.newStep.modules?.length)
            return step;
        if (step.modules !== undefined) {
            const equalModules = step.modules.every((originalModule, index) => {
                const newModule = action.newStep.modules?.[index];
                if (newModule === undefined)
                    return false;
                return originalModule.id === newModule.id && originalModule.module_type === newModule.module_type;
            });
            if (!equalModules)
                return step;
        }
        // if the step has the same name and modules, then this is the step we were looking to replace
        return action.newStep;
    });
    return newState;
}));
export const reportTitle = createReducer('', on(setReportTitle, (state, action) => action.title), on(resetAllCustomPdfReportItems, () => ''));
